import React from "react";

interface Props {
  title: string;
  description: string;
  onBack: () => void;
  children: React.ReactNode;
}

// Шапка «Заголовок + описание + ← На главную» одинаковая у нескольких полноэкранных
// разделов (администрирование, организация, личный кабинет) — раньше дублировалась
// в каждой ветке view-роутинга в App.tsx.
export default function FullPageSection({ title, description, onBack, children }: Props) {
  return (
    <main className="max-w-7xl mx-auto px-5 pt-8 w-full">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-xl md:text-2xl font-extrabold font-display text-slate-900 tracking-tight">
            {title}
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            {description}
          </p>
        </div>
        <button
          onClick={onBack}
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-display text-xs uppercase font-bold tracking-wider py-2 px-4 rounded-xl shadow-sm transition-colors cursor-pointer"
        >
          ← На главную
        </button>
      </div>
      {children}
    </main>
  );
}
